import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { getElement } from '../helpers/inputElement';
import Page from '../components/Page';
import Swal from 'sweetalert2'

export function FormDetail(
    {   form, 
        document, 
        isMultiPage = true, 
        updateDocument, 
        recordDocument, 
        sessionID,
        rulesPerPage,
        detailsPerPage,
        validate }) {


    let [index, setIndex] = useState(0);

  
    const formProgression = (Object.values(document).filter(Boolean).length/form.length)*100;

    const pageProps = {
      document,
      updateDocument,
      sessionID
    }
      
    let Pages = [];
  
    form.forEach((field) => {
      if(!Pages[field.page]) Pages[field.page] = [];
      if(field.display) {
          Pages[field.page].push(getElement(field, pageProps));
      }
    });

    let i = 0;
    Pages = Pages.map((page, index) => {
      i++;
      console.log("index ===>", index, i);
      return (<Page key={index} page={page} details={detailsPerPage[index]}></Page>)
    });
  
    const firstPage = index === 0;
    const lastPage = index === Pages.length - 1;

    function alertCallback(error) {
      Swal.fire('Formulaire', error, 'error');
    }
  
    function nextPage() {
      if (!validate(rulesPerPage[index], document, alertCallback)) return;
      window.scrollTo(0,0);
      if (lastPage) return setIndex(0);
      return setIndex(index + 1);
    }
  
    function previousPage() {
      if (firstPage) return;
      window.scrollTo(0,0);
      return setIndex(index - 1)
    }
  
    const props = {
      isMultiPage,
      firstPage,
      lastPage,
      nextPage,
      previousPage,
      document,
      recordDocument
    }
  
    const navigation = (<Navigation {...props}></Navigation>);
  
    return (
      <div style={{ backgroundImage : `url(./images/background-eiffel.jpg)` }} className="App container-contact100">
        <div className="wrap-contact100">
        <div style={{ width: `${formProgression}%` }} className="form-progress"></div>
        <img style={{ margin: '40px 5px'}} src="./images/logo-quietrent-white.svg"/>
        <div className="contact100-form validate-form slide-fade-in">
        <span className="contact100-form-title label-title">
        Etude d'éligibilité locataire
                  </span>
  
        {isMultiPage ? Pages[index] : Pages}
        <br></br>
        {navigation}
      </div>
      </div>
      </div>
    );
  }